import { EditTagBaseComponent } from './edit-tagbase/edit-tagbase.component';
import { AddTagBaseComponent } from './add-tagbase/add-tagbase.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListTagBaseComponent } from './list-tagbase/list-tagbase.component';

export const routesTagBase: Routes = [
    { path: 'page-tagbase', component: ListTagBaseComponent },
    { path: 'page-tagbase/add', component: AddTagBaseComponent },
    { path: 'page-tagbase/:id/edit', component: EditTagBaseComponent },
];

export const TagBaseRoutes: ModuleWithProviders = RouterModule.forChild(routesTagBase);
